import React from 'react';
import NewProjectView from './NewProjectView';
import useNewProjectLogic from './NewProjectLogic';

const NewProject = () => {
  const { loading, isLoggedIn } = useNewProjectLogic();
  
  return (
    <NewProjectView 
      loading={loading}
      isLoggedIn={isLoggedIn}
    />
  );
};

export default NewProject; 